import { oneOfType, object, arrayOf, bool, string } from 'prop-types'
import Icon from '../../ui/elements/Icon'
import Div from '../layout/Div'

const Buttons = ({ buttons, addons = false, cssClass = '' }) => {
  const renderButtons = buttons => {
    if (Array.isArray(buttons)) {
      return buttons.map(button => {
        return (
          renderButton(button)
        )
      })
    } else {
      return (
        renderButton(buttons)
      )
    }
  }

  const fireCallback = (button, e) => {
    e.preventDefault()
    button.parameter ? button.callback(button.parameter) : button.callback(e)
  }

  const renderButton = button => {
    return (
      <button className={`button ${button.cssClass || ''}`}
        key={Math.random().toString(36).slice(2, 5)}
        onClick={button.callback ? e => fireCallback(button, e) : () => { }}
        disabled={typeof button.disabled === 'undefined' ? false : button.disabled}
        aria-label={button.ariaLabel ? button.ariaLabel : button.text}
        style={button.style}>
        {button.icon && <Icon icon={button.icon} />}
        {button.text && <span className='button-text'> {button.text}</span >}
      </button >
    )
  }

  if (Array.isArray(buttons)) {
    return (
      <Div cssClass={`buttons ${cssClass} ${addons ? 'has-addons' : ''}`}>
        {renderButtons(buttons)}
      </Div>
    )
  } else {
    return (
      <>
        {renderButtons(buttons)}
      </>
    )
  }
}

Buttons.propTypes = {
  addons: bool,
  buttons: oneOfType([arrayOf(object), object]),
  cssClass: string
}

export default Buttons
